import { ExtensionType } from "backend/src/common/types/ExtensionCard";

import aedificator from "./aedificator.png";
import angler from "./angler.png";
import big from "./big.png";
import burrowingBase from "./burrowing-base.png";
import burrowingFed from "./burrowing-fed.png";
import camouflage from "./camouflage.png";
import chlorophyll from "./chlorophyll.png";
import communication from "./communication.png";
import cooperation from "./cooperation.png";
import crazing from "./crazing.png";
import egg from "./egg.png";
import fat from "./fat.png";
import fly from "./fly.png";
import hibernation from "./hibernation.png";
import horns from "./horns.png";
import immunity from "./immunity.png";
import ink from "./ink.png";
import intellect from "./intellect.png";
import layingEggs from "./laying-eggs.png";
import parasitePair from "./parasite-pair.png";
import parasite from "./parasite.png";
import patron from "./patron.png";
import piracy from "./piracy.png";
import poisonousAndBright from "./poisonous-and-bright.png";
import predator from "./predator.png";
import running from "./running.png";
import scavenger from "./scavenger.png";
import scream from "./scream.png";
import sharpVision from "./sharp-vision.png";
import shell from "./shell.png";
import spikes from "./spikes.png";
import swimming from "./swimming.png";
import tailLoss from "./tail-loss.png";
import transparency from "./transparency.png";
import tumor from "./tumor.png";
import viviparous from "./viviparous.png";

export const extensionImages: Partial<
  Record<
    ExtensionType | string,
    {
      full: string;
      empty: string;
    }
  >
> = {
  [ExtensionType.aedificator]: {
    empty: aedificator,
    full: aedificator,
  },
  [ExtensionType.angler]: {
    empty: angler,
    full: angler,
  },
  [ExtensionType.big]: {
    empty: big,
    full: big,
  },
  [ExtensionType.burrowing]: {
    empty: burrowingBase,
    full: burrowingFed,
  },
  [ExtensionType.camouflage]: {
    empty: camouflage,
    full: camouflage,
  },
  [ExtensionType.chlorophyll]: {
    empty: chlorophyll,
    full: chlorophyll,
  },
  [ExtensionType.communication]: {
    empty: communication,
    full: communication,
  },
  [ExtensionType.cooperation]: {
    empty: cooperation,
    full: cooperation,
  },
  [ExtensionType.crazing]: {
    empty: crazing,
    full: crazing,
  },
  [ExtensionType.egg]: {
    empty: egg,
    full: egg,
  },
  [ExtensionType.fat]: {
    empty: fat,
    full: fat,
  },
  [ExtensionType.fly]: {
    empty: fly,
    full: fly,
  },
  [ExtensionType.hibernation]: {
    empty: hibernation,
    full: hibernation,
  },
  [ExtensionType.horns]: {
    empty: horns,
    full: horns,
  },
  [ExtensionType.immunity]: {
    empty: immunity,
    full: immunity,
  },
  [ExtensionType.ink]: {
    empty: ink,
    full: ink,
  },
  [ExtensionType.intellect]: {
    empty: intellect,
    full: intellect,
  },
  [ExtensionType.layingEggs]: {
    empty: layingEggs,
    full: layingEggs,
  },
  [ExtensionType.parasite]: {
    empty: parasite,
    full: parasite,
  },
  [ExtensionType.parasitePair]: {
    empty: parasitePair,
    full: parasitePair,
  },
  [ExtensionType.patron]: {
    empty: patron,
    full: patron,
  },
  [ExtensionType.piracy]: {
    empty: piracy,
    full: piracy,
  },
  [ExtensionType.poisonous]: {
    empty: poisonousAndBright,
    full: poisonousAndBright,
  },
  [ExtensionType.pseudoPoisonous]: {
    empty: poisonousAndBright,
    full: poisonousAndBright,
  },
  [ExtensionType.predator]: {
    empty: predator,
    full: predator,
  },
  [ExtensionType.running]: {
    empty: running,
    full: running,
  },
  [ExtensionType.scavenger]: {
    empty: scavenger,
    full: scavenger,
  },
  [ExtensionType.scream]: {
    empty: scream,
    full: scream,
  },
  [ExtensionType.sharpVision]: {
    empty: sharpVision,
    full: sharpVision,
  },
  [ExtensionType.shell]: {
    empty: shell,
    full: shell,
  },
  [ExtensionType.spikes]: {
    empty: spikes,
    full: spikes,
  },
  [ExtensionType.swimming]: {
    empty: swimming,
    full: swimming,
  },
  [ExtensionType.tailLoss]: {
    empty: tailLoss,
    full: tailLoss,
  },
  [ExtensionType.transparent]: {
    empty: transparency,
    full: transparency,
  },
  [ExtensionType.tumor]: {
    empty: tumor,
    full: tumor,
  },
  [ExtensionType.viviparous]: {
    empty: viviparous,
    full: viviparous,
  },
};
